import React, { useState } from 'react';
import UploadIcon from "assets/img/svg/svgComponents/UploadIcon";
import styles from "./styles.module.scss";
import { ReactComponent as DocumentIcon } from "assets/img/svg/DocumentNoBackground.svg";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { ReactComponent as EyeIcon } from "assets/img/svg/eye.svg";
import { endpoint } from '../../../../common/constant';
import { fetchAllPostPromisedData } from '../../../../common/utils/methods/commonMethods/utilityMethod';

export const viewUploadedFileByS3Key = async (s3Key) => {

  const templateUrl = await fetchAllPostPromisedData(`${endpoint.fetchS3Url.getDownloadUrl}?key=${s3Key}`, {})
  if (templateUrl?.code === 200 && templateUrl?.data) {
    const resp = await fetch(templateUrl?.data?.url);
    if (resp.ok) {
      const pdfFile = await resp.blob();
      const blobUrl = URL.createObjectURL(pdfFile);
      window.open(blobUrl);

    }
  }


}

export const UploadedFile = ({ formHandler, viewOnly = false , keyFieldName, fileName = "Attachment", attachmentKey}) => {

    const [loading , setLoading] = useState(false);

    const handleEyeIconClick = async() => {
        try{
            setLoading(true);
            await viewUploadedFileByS3Key(attachmentKey)
        }catch(err){
            console.error(err);
        }finally{
            setLoading(false);
        }
    }

    return (
        <span className={styles['attachment-info']}>
            <DocumentIcon className={styles['icon']} />
            {fileName}
            {attachmentKey && (
                loading
                ? <i className={"fas fa-spinner fa-spin " + styles['icon']} aria-hidden="true" />
                : <EyeIcon onClick={handleEyeIconClick} className={styles['icon'] + " cursor"}/> 
            )}
            {!viewOnly && <CrossIcon onClick={() => formHandler(keyFieldName, "")} className={styles['icon']} />}
        </span >
    )
}

const UploadDocument = ({
    attachmentKey,
    setUploadDialogOpen = () => {},
    formHandler,
    labelStyle = {},
    viewOnly = false,
    keyFieldName = "attachmentKey",
    label = "Add Attachment",
    uploadIconClickHandler = () => setUploadDialogOpen(true),
    fileName = "Attachment"
}) => {
    return (
        <div>
            <div className={`${styles['label']}`} style={labelStyle}>{label}</div>
            <div className={`${styles['field-wrapper']} d-flex justify-content-between`} style={{backgroundColor : viewOnly ? '#EDEDED' : ''}}>
                {
                    attachmentKey
                        ? <UploadedFile formHandler={formHandler} viewOnly={viewOnly} keyFieldName={keyFieldName} fileName={fileName} attachmentKey={attachmentKey}/>
                        : <span>{viewOnly ? "No File Uploaded" : "Upload"}</span>
                }
                {!viewOnly && <span className="cursor" onClick={uploadIconClickHandler}><UploadIcon /></span>}
            </div>
        </div>
    );
}

export default UploadDocument;